<template>
  <div class="box-main">
    <div class="main">
      <div>
        <div class="main-title">定向升级</div>
        <div class="main-title-tips">可对不同升级策略信息进行查看和操作</div>
      </div>
      <div class="main-center">
        <v-button class="v-icon-add" v-permission="'upgrade:policy:add'" type="primary" name="" @click="showAdd">添加</v-button>
        <v-input
              class="inputsearch"
              v-model="searchValue"
              placeholder="请输入搜索内容"
              suffix-icon="v-icon-search"
              @change="searchdata"
        ></v-input>
      </div>
      <div>
        <vxe-table
            border
            row-id="id"
            :data="table"
            @cell-click="cellClickEvent"
            align="left"
            :row-style="setRowClass"
          >
            <vxe-table-column field="id" show-overflow min-width="50" title="ID"></vxe-table-column>
            <vxe-table-column field="strategy_typeshow" show-overflow min-width="160" title="策略类型"></vxe-table-column>
            <vxe-table-column field="source_ver" show-overflow min-width="160" title="源版本"></vxe-table-column>
            <vxe-table-column field="target_ver" show-overflow min-width="160" title="目标版本"></vxe-table-column>
            <vxe-table-column field="created_at" show-overflow min-width="160" title="上传时间"></vxe-table-column>
            <vxe-table-column field="updated_at" show-overflow min-width="160" title="更新时间"></vxe-table-column>
            <vxe-column title="操作" min-width="180">
              <template v-slot="slotProps">
                <span class="handle-button"><v-button size="S" type="text" name="btn1" slot="reference" @click="showEdit(slotProps.row)">编辑</v-button></span>
                <span class="handle-button"><v-button size="S" type="text" name="btn2" slot="reference" @click="showDown(slotProps.row)">下载</v-button></span>
                <span class="handle-button"><v-button size="S" type="text" name="btn3" slot="reference" @click="showDel(slotProps.row)">删除</v-button></span>
                <span class="handle-button"><v-button size="S" type="text" name="btn4" slot="reference" @click="showDetails(slotProps.row)">详情</v-button></span>
              </template>
            </vxe-column>
          </vxe-table>
      </div>
      <v-pagination v-if="total" @change-page="changePage" @change-size="changeSize" :total="total" name="page-basic" is-show-total is-change-size is-input-page :current-page="this.currentPage" ></v-pagination>
    </div>
      <UpgradeStrategy :showInputDialog.sync="showAddDialog" ref="upgradeStrategy" :UseId="showID" @getData="getData()"></UpgradeStrategy>
      <Edit :showInputDialog.sync="showEditDialog" ref="Edit" :row="row" @getData="getData" ></Edit>
      <Down :showInputDialog.sync="Downloading" ref="Down" :UseId="showID" :file_url="dowmfile_url" ></Down>
      <Del :showInputDialog.sync="Delloading" ref="Del" :UseId="showID" @getData="getData()"></Del>
      <Details :showInputDialog.sync="Detailsloading" ref="Details" :row="row" @getData="getData()"></Details>
  </div>
</template>
<script>
import UpgradeStrategy from "@/components/policy-set/upgrade-strategy.vue";
import Edit from "@/components/policy-set/edit.vue";
import Del from "@/components/policy-set/del.vue";
import Down from "@/components/policy-set/down.vue";
import Details from "@/components/policy-set/policy-details.vue";
import { STRATEGY_TYPE } from "@/common/libs/Contains";
export default {
  components: { UpgradeStrategy ,Del,Down,Details,Edit},
  data() {
    return {
      search:'',
      searchData:'',
      Downloading:false,
      Delloading:false,
      showAddDialog: false,
      Detailsloading:false,
      showEditDialog:false,
      showID:'',
      searchValue:'',
      dowmfile_url:'',
      row:{},
      currentPage: 1,
      pageSize: 10,
      table: [],
      total: 0,
    };
  },
  created() {
    this.getData()
  },
  methods: {
    cellClickEvent({row, column}){
      if(column.title == '操作'){
        return
      }else{
      this.showDetails(row)
      }
    },
    setRowClass({rowIndex}){
       if( rowIndex%2!==0){
          return "background: #fafafa";
       }
    },
    searchAll(){
        this.searchData = this.search
        if("基于设备KEY和MAC".indexOf(this.search) != -1){ this.searchData = 'base-mac' }
        if("基于设备KEY".indexOf(this.search) != -1){ this.searchData = 'base-sn' }
        if(this.search == ''){this.searchData = ''}
        this.search = this.searchData
      },
    async getData(){
      const subData = {
        page_num: this.currentPage,
        page_size: this.pageSize,
        search: this.searchData,
        app_id: sessionStorage.getItem("appid") || "",
      };
      const res = await this.$getData(
        "/td/td-iot-api/iot/white-list/list/v1",
        subData
      );
      if(res.code === 0){
        this.table = res.data.list
        this.table.forEach((x)=>{
          x.strategy_typeshow = STRATEGY_TYPE[x.strategy_type]
        })
        this.total = res.data.page_result.total
      }else{
        if(res.code == '100410'){
          setTimeout(() => {
            this.getData()
          },1000)
        }else{
          this.$message.error(res.msg);
        }
      }
    },
    searchdata(){
      this.currentPage = 1
      this.search = this.searchValue
      this.searchAll()
      this.getData()
    },
    changePage(page){
        this.currentPage = page
        this.getData()
      },
      changeSize(size){
        this.pageSize = size
        this.currentPage = 1
        this.getData()
      },
    showAdd(){
      this.showAddDialog = !this.showAddDialog
    },
    showEdit(row){
      this.showEditDialog = !this.showEditDialog
      if(this.showEditDialog == true){
        this.row = row
      }
    },
    showDown(row){
      this.Downloading = !this.Downloading
      if(this.Downloading == true){
        this.dowmfile_url = row.file_url
      }
    },
    showDel(row){
      this.Delloading = !this.Delloading
      if(this.Delloading == true){
        this.showID = row.id
      }
    },
    showDetails(row){
      this.Detailsloading = !this.Detailsloading
      if(this.Detailsloading == true){
        this.row = row
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">

</style>
